<template>
	<div>
		<default-widget-field v-bind="googleDocsFieldProps" v-on="defaultFieldListeners" />
		<iframe :src="docsLink" style="width: 100%; min-height: 600px"></iframe>
	</div>
</template>

<script>
import DefaultWidgetField from './DefaultWidgetField';
import WidgetFieldMixin from './WidgetFieldMixin';
import { GOOGLE_DOCS_BASE_URL } from '../google-docs-mini-app.const';
import WidgetFormService from '@/components/WidgetForm/WidgetFormService';

function buildURL({ string, editMode, rmParam }) {
	try {
		const baseUrl = new URL(`${GOOGLE_DOCS_BASE_URL}${string}/${editMode}`);
		baseUrl.searchParams.append('embedded', 'true');
		baseUrl.searchParams.append('rm', rmParam);
		return baseUrl.toString();
	} catch (e) {
		return string;
	}
}

export default {
	name: 'GoogleDocsInputField',
	components: {
		DefaultWidgetField,
	},
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},
	mixins: [WidgetFieldMixin],
	computed: {
		metadataOptions() {
			return this.field.metadata.options;
		},
		currentPreviousSteps() {
			return this.previousSteps || this.flatPreviousSteps;
		},
		docsId() {
			return WidgetFormService.processPreviousSteps(this.metadataOptions.docs_id.value, this.currentPreviousSteps);
		},
		rmParam() {
			return WidgetFormService.processPreviousSteps(this.metadataOptions.rm_param.value, this.currentPreviousSteps);
		},
		editMode() {
			return WidgetFormService.processPreviousSteps(this.metadataOptions.edit_mode.value, this.currentPreviousSteps);
		},
		docsLink() {
			return buildURL({ string: this.docsId, editMode: this.editMode, rmParam: this.rmParam });
		},
		googleDocsFieldProps() {
			return { ...this.defaultFieldProps, titleEnabled: false };
		},
	},
	methods: {},
	async mounted() {},
	data: () => ({
		isConfirming: false,
	}),
};
</script>
<style scoped lang="scss"></style>
<style lang="scss"></style>
